import type { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import LineItemSummaryService from '@/Services/CampaignManagement/LineItemSummary.service';
import { useAppSelector } from '@/store/hooks';
import { selectCampaignManagementProducts } from '@/store/selectors/campaignManagement.selectors';
import { selectShowBidCpmControl, selectShowRateCardCpmControl } from '@/store/selectors/currentWhitelabel.selectors';
import { selectSharedApiPackages } from '@/store/selectors/sharedApi.selectors';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import InfoTable, { rowspanTableMaxRows } from './InfoTable';

const BasicInfo = memo(() => {
  const showBidCpmControl = useAppSelector(selectShowBidCpmControl);
  const showRateCardCpmControl = useAppSelector(selectShowRateCardCpmControl);

  const { getValues } = useFormContext<ILineItemForm>();
  const { products: productsWithPublishers } = useAppSelector(selectCampaignManagementProducts);
  const { packages } = useAppSelector(selectSharedApiPackages);

  const values = getValues();

  const packageName = packages.find(pkg => pkg.id === Number(values.packageId))?.name;

  const basicInfoRows = LineItemSummaryService.getBasicInfo(values, {
    showBidCpmControl,
    showRateCardCpmControl,
    packageName,
  });
  const publishers = values.channel?.label
    ? productsWithPublishers?.[values.channel.label]?.products?.find(product => product.id === values.product?.id)
        ?.publishers
    : null;
  const publisherRows = LineItemSummaryService.getPublishersInfo(values, publishers);

  return (
    <>
      {basicInfoRows.length ? <InfoTable caption='Essential Settings' rows={basicInfoRows} /> : null}
      {publisherRows.length ? (
        <InfoTable caption='Publishers' rows={publisherRows} maxRows={rowspanTableMaxRows} />
      ) : null}
    </>
  );
});

export default BasicInfo;
